const TRANSPORT_ID_SEPARATOR = 'SCH';

// A transport id reads <searchProductId>SCH<internalIdTransport>, and the searchProductId is minted
// anew with every pricing: once reloaded, the page offers the same flight under another id — the
// url's own transportId comes back the same way. What follows the separator names the flight.
export function getFlightKey(transportId: string) {
  const separatorIndex = transportId.indexOf(TRANSPORT_ID_SEPARATOR);
  return separatorIndex < 0 ? transportId : transportId.slice(separatorIndex + TRANSPORT_ID_SEPARATOR.length);
}
